import { getTransactionQueryKey } from '@src/orders/hooks/useGetOrderTransactions';
import { useRefreshInvoice } from '@src/orders/hooks/useReviewableOrder';
import { PaymentClient } from '@src/orders/services/PaymentClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface Props {
  orderId: string;
  onSuccess: ({ amount }: { amount: number }) => void;
  onError: () => void;
}

export const useSettleTransaction = ({
  orderId,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();
  const { refreshInvoice } = useRefreshInvoice({ orderId });

  const refreshTransactions = async () =>
    queryClient.resetQueries({
      queryKey: getTransactionQueryKey({ orderId }),
    });

  const { mutateAsync: settle } = useMutation({
    mutationFn: ({
      amount,
      transactionId,
    }: {
      amount: number;
      transactionId: string;
    }) => PaymentClient.settle({ amount, transactionId }),
    onSuccess: async ({ amount }) => {
      await refreshTransactions();
      refreshInvoice();
      onSuccess({ amount });
    },
    onError: async () => {
      await refreshTransactions();
      onError();
    },
  });

  return {
    settle,
  };
};
